import axios from 'axios';
import { useQuery } from 'react-query';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 302 — the known Sales Bible "Platform" names (the combobox option list). New names
// are persisted by the SalesBibleUpdateAction on commit (get-or-create), so the list grows
// as platforms are used.
const usePlatforms = () => useQuery('platforms', async (): Promise<string[]> => {
  const { data } = await axios.get(`${apiUrl()}Platform`);
  return data;
});

export default usePlatforms;
